import { IStyle } from '@fluentui/react';

type ScreenSizedKeys = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

type ScreenSizes = {
  [key in ScreenSizedKeys]: number;
};

// The breakpoints are taken from here: https://xd.adobe.com/view/eebb600c-026b-4ca1-bb6b-0a439235452b-bbe8/
export const screenSizes: ScreenSizes = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
};

export const queryMobile = `(max-width: ${screenSizes.md - 1}px)`;
export const queryTablet = `(min-width: ${screenSizes.md}px) and (max-width: ${screenSizes.lg - 1}px)`;
export const queryDesktop = `(min-width: ${screenSizes.lg}px)`;
export const queryNoMobile = `(min-width: ${screenSizes.md}px)`;
export const queryNoDesktop = `(max-width: ${screenSizes.lg - 1}px)`;

export const mediaMobile = (styles: IStyle) => ({ [`@media ${queryMobile}`]: styles });
export const mediaTablet = (styles: IStyle) => ({ [`@media ${queryTablet}`]: styles });
export const mediaDesktop = (styles: IStyle) => ({ [`@media ${queryDesktop}`]: styles });
export const mediaNoMobile = (styles: IStyle) => ({ [`@media ${queryNoMobile}`]: styles });
export const mediaNoDesktop = (styles: IStyle) => ({ [`@media ${queryNoDesktop}`]: styles });

export type IStyles<T extends string | number | symbol> = {
  [key in T]?: IStyle;
};

export type StyleClassNames<T extends string | number | symbol> = {
  [key in T]?: string;
};
